import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

import { computed, toRefs, watch } from 'vue'
import FeatureNavigationButton from './FeatureNavigationButton.vue'
import { useStore } from 'vuex'
import useFeatures from '@/pinia/features'
import { Feature } from '@/pinia/feature'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'FeatureNavigation',
  setup(__props) {

const store = useStore()
const features = useFeatures()
const { locale, t } = useI18n()
const { hasFeatureAccess, resetMainFeature, setMainFeature } = features
const { featurePath, mainFeatures } = toRefs(features)
const isDrawPointActive = computed<boolean>(() => store.getters.isDrawPointActive)
const isIndoorviewShowing = computed<boolean>(() => store.getters.isIndoorviewShowing)
const activeFeature = computed<string | null>(() =>
  featurePath.value.length > 1 ? featurePath.value[1] : null
)

function disabledFeature(feature: Feature): boolean {
  const disabledInIndoorview =
    isIndoorviewShowing.value &&
    (feature.name === 'analytics' || feature.name === 'project-analysis')
  return (
    disabledInIndoorview || (feature.props?.disableIsDrawPointActive && isDrawPointActive.value)
  )
}
function getTitle(feature: Feature): string {
  return disabledFeature(feature)
    ? `${feature.title[locale.value]} (${t('general__view__function-disabled').toLowerCase()})`
    : feature.title[locale.value]
}
function onFeatureClick(feature: string) {
  const state = feature === activeFeature.value
  if (state) {
    resetMainFeature()
  } else {
    setMainFeature(feature)
  }
}

watch(isIndoorviewShowing, (isShowing) => {
  if (isShowing) {
    resetMainFeature()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_UserMessage = _resolveComponent("UserMessage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mainFeatures), (feature) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: feature.id
        }, [
          (feature.enabled && _unref(hasFeatureAccess)(feature))
            ? (_openBlock(), _createBlock(FeatureNavigationButton, {
                key: 0,
                id: `${feature.name}-feature`,
                isSelected: activeFeature.value === feature.name,
                disabled: disabledFeature(feature),
                title: getTitle(feature),
                onOnClick: () => onFeatureClick(feature.name)
              }, {
                icon: _withCtx(() => [
                  (feature.props)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(feature.props?.icon), { key: 0 }))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["id", "isSelected", "disabled", "title", "onOnClick"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    _createVNode(_component_UserMessage)
  ], 64))
}
}

})